import type { CSSObject } from '@emotion/react';

import { theme } from './theme';

/**
 * Reusable thin, subtle scrollbar styling that matches the dark design system.
 * Spread into a styled component or an `sx` prop on any scrollable container.
 *
 * @example
 * const Scrollable = styled('div')({ overflowY: 'auto', ...scrollbarStyles });
 */
export const scrollbarStyles: CSSObject = {
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.colors.white[20],
    borderRadius: '8px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.colors.white[40],
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.colors.white[20]} transparent`,
};
